export function profileLoading(theme) {
    return (
        <div className="kfmmvkde3">
            <div className="ppdowo23x">
                <div className={`kdkkwl223 shimmer ${theme}`}></div>
                <div className={`dfeertf34 shimmer ${theme}`}></div>
            </div>
            <div className={`dfffertgb shimmer ${theme}`}>

            </div>
        </div>
    )
}